import { Component, ViewChild, OnInit } from '@angular/core';
import { DateRange } from '../../entity';
import { Calendar } from 'primeng/calendar';
import { FinesService } from '../../service/main/fines.service';
import { VehicleCheck } from '../../entity/other-entities/vehicle-check';
import { Table } from 'primeng/table';
import Enums from '../../utils/enums';
import { SelectItem, DialogService } from 'primeng/api';
import { Router } from '@angular/router';
import { DynamicMapComponent } from '../common/dynamic-map/dynamic-map.component';

@Component({
    selector: 'app-vehicle-checks',
    templateUrl: './vehicle-checks.component.html',
    providers: [DialogService]
})
export class VehicleChecksComponent implements OnInit {
    checks: Array<VehicleCheck> = new Array<VehicleCheck>();

    //#region calendar properties
    @ViewChild('rangeCalendar') rangeCalendar: Calendar;
    rangeDates: Date[];
    isFirstSelected = false;
    dateRange: DateRange = new DateRange();
    //#endregion

    //#region component state properties
    loadingState = false;
    noRecordsState = true;
    //#endregion

    //#region table properties
    @ViewChild('checksTable') checksTable: Table;
    cols: any[];
    checkStats: SelectItem[];
    //#endregion

    constructor(
        private finesService: FinesService,
        private router: Router,
        public dialogService: DialogService
    ) { }

    ngOnInit(): void {
        this.cols = [
            { field: 'AuthorName', header: 'Enforcer' },
            { field: 'Plate', header: 'Masina' },
            { field: 'VehicleCheckStat', header: 'Status' },
            { field: 'PvNote', header: 'Proces Verbal' },
            { field: 'Note', header: 'Nota' },
            { field: 'Date', header: 'Data' }
        ];

        this.checkStats = [
            { label: 'Toate', value: null },
            { label: 'Valide', value: 'Valid' },
            { label: 'Vehicul electric', value: 'Vehicul electric' },
            { label: 'Neamendate', value: 'Neamendat' },
            { label: 'Amendate anterior', value: 'Amendat anterior' },
            { label: 'De Amendat', value: 'De Amendat' },
            { label: 'Verificate', value: 'Verificat' },
            { label: 'Anulate', value: 'Anulat' },
            { label: 'Amendate', value: 'Amendat' },
        ];

        this.refresh();
    }

    refresh(): void {
        if (this.finesService.checksDateRange) {
            const { StartDate, EndDate } = this.finesService.checksDateRange;
            this.getChecks(this.finesService.checksDateRange);
            this.rangeDates = [StartDate, EndDate];
        } else {
            this.getChecks(new DateRange(new Date(), new Date()));
            let dateNext = new Date();
            dateNext.setDate(dateNext.getDate() + 1);
            this.rangeDates = [new Date(), dateNext];
        }
    }

    getChecks(dateRange: DateRange) {
        this.loadingState = true;
        this.noRecordsState = false;
        this.checks = new Array<VehicleCheck>();

        this.finesService.getVehicleChecks(dateRange).subscribe(data => {
            const checks = new Array<VehicleCheck>();
            data.forEach(item => {
                const check = new VehicleCheck();
                check.fromObject(item);

                check.VehicleCheckStat = this.getStatByID(check.VehicleCheckStatID, check.FineStatID);

                checks.push(check);
            });
            this.checks = checks;
            this.loadingState = false;

            if (this.checks.length > 0) {
                this.noRecordsState = false;
            } else {
                this.noRecordsState = true;
            }
        }, (err) => {
            this.loadingState = false;
            this.noRecordsState = true;
        });
    }

    onSelectCheck(check: VehicleCheck) {
        const { FineID, VehicleCheckID, Latitude, Longitude } = check;

        if (FineID) {
            this.router.navigateByUrl(`/fines/${FineID}`);
        } else {
            this.router.navigateByUrl(`/vehicle-checks/${VehicleCheckID}`);
            // this.dialogService.open(
            //     DynamicMapComponent,
            //     {
            //         header: 'Locatie',
            //         width: '70%',
            //         data: { Latitude, Longitude }
            //     }
            // );
        }
    }

    getStatByID(checkStatID: number, fineStatID: number): string {
        if (fineStatID === Enums.eFineStat.Issued || fineStatID === 0) {
            switch (checkStatID) {
                case Enums.eVehicleCheckStat.Valid:
                    return 'Valid';
                case Enums.eVehicleCheckStat.Invalid:
                    return 'Neamendat';
                case Enums.eVehicleCheckStat.ToBeFined:
                    return 'De Amendat';
                case Enums.eVehicleCheckStat.PreviouslyFined:
                    return 'Amendat anterior';
                case Enums.eVehicleCheckStat.ElectricException:
                    return 'Vehicul electric';
                case Enums.eVehicleCheckStat.Subscription:
                    return 'Abonament';
            }
        } else {
            switch (fineStatID) {
                case Enums.eFineStat.Processed:
                    return 'Verificat';
                case Enums.eFineStat.Cancelled:
                    return 'Anulat';
                case Enums.eFineStat.Fined:
                    return 'Amendat';
            }
        }
    }

    getClassByState(check: VehicleCheck): string {
        if (check.FineStatID === Enums.eFineStat.Issued || check.FineStatID === 0) {
            switch (check.VehicleCheckStatID) {
                case Enums.eVehicleCheckStat.Valid:
                    return 'badge-success';
                case Enums.eVehicleCheckStat.Invalid:
                    return 'badge-danger';
                case Enums.eVehicleCheckStat.ToBeFined:
                    return 'badge-warning';
                case Enums.eVehicleCheckStat.PreviouslyFined:
                    return 'badge-primary';
                case Enums.eVehicleCheckStat.ElectricException:
                    return 'badge-success';
                case Enums.eVehicleCheckStat.Subscription:
                    return 'badge-success';
            }
        } else {
            switch (check.FineStatID) {
                case Enums.eFineStat.Processed:
                    return 'badge-success';
                case Enums.eFineStat.Cancelled:
                    return 'badge-danger';
                case Enums.eFineStat.Fined:
                    return 'badge-primary';
            }
        }
    }

    //#region calendar methods
    selectDates(date: Date): void {
        date.setHours(3);

        if (!this.isFirstSelected) {
            this.dateRange.StartDate = date;
            this.isFirstSelected = true;
        } else {
            this.dateRange.EndDate = date;
            this.isFirstSelected = false;
            this.getChecks(this.dateRange);
            this.rangeCalendar.overlayVisible = false;
        }

        this.checksTable.first = 1;
    }

    clearSessionState(): void {
        sessionStorage.removeItem('checks-table-state');
    }
    //#endregion
}
